module.exports = __webpack_public_path__ + "static/media/image1.e5ff3f2b.png";